import React, { useEffect, useState } from "react";

import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Textarea } from "../../../components/ui/textarea";

export function CompanyForm({ company, onSubmit, onCancel, isSubmitting }) {
	const [formData, setFormData] = useState({
		company_name: "",
		linkedin_url: "",
		linkedin_followers_count: "N/A",
		logo_url: "",
		about_us: "",
		company_website: "",
		company_industry: "",
		company_size_approx: "",
		headquarters: "",
		type: "",
		funding: "N/A",
		funding_total_rounds: "N/A",
		funding_option: "N/A",
		last_funding_round: "N/A",
		locations: [],
		founded: "",
		specialties: "",
		about_us_summary: "",
	});

	useEffect(() => {
		if (company) {
			setFormData({
				company_name: company.company_name || "",
				linkedin_url: company.linkedin_url || "",
				linkedin_followers_count: company.linkedin_followers_count || "N/A",
				logo_url: company.logo_url || "",
				about_us: company.about_us || "",
				company_website: company.company_website || "",
				company_industry: company.company_industry || "",
				company_size_approx: company.company_size_approx || "",
				headquarters: company.headquarters || "",
				type: company.type || "",
				funding: company.funding || "N/A",
				funding_total_rounds: company.funding_total_rounds || "N/A",
				funding_option: company.funding_option || "N/A",
				last_funding_round: company.last_funding_round || "N/A",
				locations: company.locations || [],
				founded: company.founded || "",
				specialties: company.specialties || "",
				about_us_summary: company.about_us_summary || "",
			});
		}
	}, [company]);

	const handleInputChange = (field, value) => {
		setFormData((prev) => ({ ...prev, [field]: value }));
	};

	const handleLocationsChange = (value) => {
		const locations = value
			.split(",")
			.map((loc) => loc.trim())
			.filter((loc) => loc);
		setFormData((prev) => ({ ...prev, locations }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		delete formData.company_website; // Remove company_website if not needed
		onSubmit(formData);
	};

	return (
		<form onSubmit={handleSubmit} className="space-y-6">
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="company_name">
						Company Name *
					</Label>
					<Input
						id="company_name"
						className="!rounded-md"
						value={formData.company_name}
						onChange={(e) => handleInputChange("company_name", e.target.value)}
						required
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="company_industry">
						Industry
					</Label>
					<Input
						className="!rounded-md"
						id="company_industry"
						value={formData.company_industry || ""}
						onChange={(e) => handleInputChange("company_industry", e.target.value)}
					/>
				</div>
				{/* 
				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="company_website">
						Website
					</Label>
					<Input
						id="company_website"
						type="url"
						className="!rounded-md"
						value={formData.company_website || ""}
						onChange={(e) => handleInputChange("company_website", e.target.value)}
					/>
				</div> */}

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="linkedin_url">
						LinkedIn URL
					</Label>
					<Input
						id="linkedin_url"
						className="!rounded-md"
						type="url"
						value={formData.linkedin_url || ""}
						onChange={(e) => handleInputChange("linkedin_url", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="logo_url">
						Logo URL
					</Label>
					<Input
						id="logo_url"
						type="url"
						className="!rounded-md"
						value={formData.logo_url || ""}
						onChange={(e) => handleInputChange("logo_url", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="headquarters">
						Headquarters
					</Label>
					<Input
						id="headquarters"
						className="!rounded-md"
						value={formData.headquarters || ""}
						onChange={(e) => handleInputChange("headquarters", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="founded">
						Founded
					</Label>
					<Input
						id="founded"
						className="!rounded-md"
						value={formData.founded || ""}
						onChange={(e) => handleInputChange("founded", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="company_size_approx">
						Company Size
					</Label>
					<Input
						id="company_size_approx"
						className="!rounded-md"
						value={formData.company_size_approx || ""}
						onChange={(e) => handleInputChange("company_size_approx", e.target.value)}
						placeholder="e.g., 1-10, 11-50, 51-200"
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="type">
						Company Type
					</Label>
					<Input
						id="type"
						value={formData.type || ""}
						onChange={(e) => handleInputChange("type", e.target.value)}
						className="!rounded-md"
						placeholder="e.g., Public, Private, Non-profit"
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="linkedin_followers_count">
						LinkedIn Followers
					</Label>
					<Input
						id="linkedin_followers_count"
						value={formData.linkedin_followers_count}
						className="!rounded-md"
						onChange={(e) => handleInputChange("linkedin_followers_count", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="funding">
						Funding
					</Label>
					<Input
						id="funding"
						className="!rounded-md"
						value={formData.funding}
						onChange={(e) => handleInputChange("funding", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="funding_total_rounds">
						Total Funding Rounds
					</Label>
					<Input
						className="!rounded-md"
						id="funding_total_rounds"
						value={formData.funding_total_rounds}
						onChange={(e) => handleInputChange("funding_total_rounds", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="funding_option">
						Funding Option
					</Label>
					<Input
						className="!rounded-md"
						id="funding_option"
						value={formData.funding_option}
						onChange={(e) => handleInputChange("funding_option", e.target.value)}
					/>
				</div>

				<div className="space-y-2">
					<Label className="font-medium !mb-0" htmlFor="last_funding_round">
						Last Funding Round
					</Label>
					<Input
						id="last_funding_round"
						className="!rounded-md"
						value={formData.last_funding_round}
						onChange={(e) => handleInputChange("last_funding_round", e.target.value)}
					/>
				</div>
			</div>

			<div className="space-y-2">
				<Label className="font-medium !mb-0" htmlFor="locations">
					Locations (comma-separated)
				</Label>
				<Input
					id="locations"
					value={formData.locations?.join(", ") || ""}
					className="!rounded-md"
					onChange={(e) => handleLocationsChange(e.target.value)}
					placeholder="e.g., New York, London, Tokyo"
				/>
			</div>

			<div className="space-y-2">
				<Label className="font-medium !mb-0" htmlFor="specialties">
					Specialties
				</Label>
				<Textarea
					id="specialties"
					value={formData.specialties || ""}
					className="!rounded-md"
					onChange={(e) => handleInputChange("specialties", e.target.value)}
					rows={3}
				/>
			</div>

			<div className="space-y-2">
				<Label className="font-medium !mb-0" htmlFor="about_us">
					About Us
				</Label>
				<Textarea
					id="about_us"
					className="!rounded-md"
					value={formData.about_us || ""}
					onChange={(e) => handleInputChange("about_us", e.target.value)}
					rows={4}
				/>
			</div>

			<div className="space-y-2">
				<Label className="font-medium !mb-0" htmlFor="about_us_summary">
					About Us Summary
				</Label>
				<Textarea
					id="about_us_summary"
					className="!rounded-md"
					value={formData.about_us_summary || ""}
					onChange={(e) => handleInputChange("about_us_summary", e.target.value)}
					rows={3}
				/>
			</div>

			<div className="flex justify-end space-x-2 pt-4">
				<Button type="button" className="!rounded-md" variant="outline" onClick={onCancel}>
					Cancel
				</Button>
				<Button type="submit" className="!bg-primary-700 !rounded-md" disabled={isSubmitting}>
					{isSubmitting ? "Saving..." : company ? "Update Company" : "Create Company"}
				</Button>
			</div>
		</form>
	);
}
